"use client";

import { Button } from "@/components/ui/button-pro";
import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { FaComputer, FaRegMoon, FaRegSun } from "react-icons/fa6";

import {
    NavigationMenu,
    NavigationMenuContent,
    NavigationMenuItem,
    NavigationMenuLink,
    NavigationMenuList,
    NavigationMenuTrigger
} from "@/components/ui/navigation-menu";
import { NavigationMenuSub } from "@radix-ui/react-navigation-menu";
import { Separator } from "../ui/separator";

export function ThemeToggle() {
  const { setTheme, theme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), [setMounted]);

  const toggleTheme = () => {
    setTheme(theme === "dark" ? "light" : "dark");
  };

  if (!mounted) return null;

  return (
    <>
      <Button
        key={theme}
        variant="ghost"
        size="smIcon"
        className="hover:text-blue shadow-md dark:hover:text-accent-green"
        onClick={toggleTheme}
      >
        {theme === "dark" ? (
          <FaRegSun className="w-5 h-5 text-orange-300" />
        ) : (
          <FaRegMoon className="w-5 h-5 text-blue-700" />
        )}
      </Button>
      <span className="sr-only">Toggle theme</span>
    </>
  );
}

export function ThemeToggleNew() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch by only rendering after mount
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <Button variant="ghost" size="icon" className="w-10 h-10 rounded-full">
        <span className="sr-only">Toggle theme</span>
        <div className="w-5 h-5 bg-gray-400/20 rounded-full animate-pulse" />
      </Button>
    );
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={() => setTheme(theme === "light" ? "dark" : "light")}
      className="w-10 h-10 rounded-full bg-gray-800/50 dark:bg-white/10 hover:bg-gray-700/70 dark:hover:bg-white/20 transition-all duration-300"
      aria-label="Toggle theme"
    >
      <Sun className="h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 text-yellow-400" />
      <Moon className="absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 text-purple-300" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}

export function ThemeToggleList() {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  // const toggleTheme = () => {
  //     setTheme(theme === 'dark' ? 'light' : 'dark');
  // };

  if (!mounted) return null;

  return (
    // <Button
    //     variant='ghost'
    //     size='icon'
    //     onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
    //     className='w-10 h-10 rounded-full bg-gray-800/50 dark:bg-white/10 hover:bg-gray-700/70 dark:hover:bg-white/20 transition-all duration-300'
    //     aria-label='Toggle theme'>
    //     <Sun className='h-5 w-5 rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0 text-yellow-400' />
    //     <Moon className='absolute h-5 w-5 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100 text-purple-300' />
    //     <span className='sr-only'>Toggle theme</span>
    // </Button>
    <NavigationMenu>
      <NavigationMenuList>
        <NavigationMenuItem>
          <NavigationMenuTrigger>
            Theme{" "}
            {theme === "system" ? (
              <FaComputer className="w-5 h-5 text-blue-700" />
            ) : theme === "dark" ? (
              <FaRegMoon className="w-5 h-5 text-blue-700" />
            ) : (
              <FaRegSun className="w-5 h-5 text-orange-300" />
            )}
          </NavigationMenuTrigger>
          <NavigationMenuContent className="bg-gray-100 dark:bg-gray-900 w-full">
            <NavigationMenuLink>Choose Theme</NavigationMenuLink>
            <Separator className="my-2" />
            <NavigationMenuLink onClick={() => setTheme("light")}>
              <FaRegSun className="w-5 h-5 text-orange-300" /> Light
            </NavigationMenuLink>
            <NavigationMenuLink onClick={() => setTheme("dark")}>
              <FaRegMoon className="w-5 h-5 text-blue-700" /> Dark
            </NavigationMenuLink>
            <NavigationMenuLink onClick={() => setTheme("system")}>
              <FaComputer className="w-5 h-5 text-blue-700" /> System
            </NavigationMenuLink>
            <Separator />
            <NavigationMenuSub>Current: {theme}</NavigationMenuSub>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
